// extracted by mini-css-extract-plugin
export var container = "_tr-0";
export var table = "_tr-2";
export var tableWrapper = "_tr-1";